// src/components/footer.jsx

import './footer.scss';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Cvrle DOO</p>
        <nav>
          <ul>
            <li><a href="/">Početna Stranica</a></li>
            <li><a href="/contact">Kontakt</a></li>
            <li><a href="https://cvrleoutlet.co.rs/">Cvrle Outlet</a></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
